export interface ProjectTreeCounts {
  projectId: number;
  treeCount: number;
}
export interface ReferralTree {
  _id: string;
  username: string;
  groupName: string;
  firstName: string;
  lastName: string;
  createdAt: Date;
  isPrivate: boolean;
  projectId: number;
  totalTrees: number;
  projectTreeCounts: ProjectTreeCounts[];
  userId?: string;
}

export type ReferralImpact = {
  trees: ReferralTree[];
};
